import React, { useContext, useEffect, useState } from 'react';
import styled from 'styled-components';
import { FAD_Button_Outline, FAD_Button_Primary } from '../components/FadButtons';
import { IoIosArrowBack } from 'react-icons/io';
import { FaListAlt, FaPlay } from 'react-icons/fa';
import { BsFillSendFill } from 'react-icons/bs';
import { useHistory, useParams } from 'react-router-dom';
import Colors from 'enums/Colors';
import { MdEditSquare, MdPublic, MdSaveAs } from 'react-icons/md';
import { FadCoursesService } from 'core/http/service/ferramentaAutoria/FadCourses.service';
import { FadCoursesModel, IFadClasseCertificado } from 'models/ferramentaAutoria/FadCoursesModel';
import TemplateCourse, { TemplateCourseFadEnum } from '../components/courses/TemplateCourse';
import FadAdds from '../components/adds/FadAdds';
import { FadModulesModel } from 'models/ferramentaAutoria/FadModulesModel';
import { FadModulesService } from 'core/http/service/ferramentaAutoria/FadModules.service';
import useFetch from 'hooks/useFetch';
import FadListModules from '../components/modules/FadListModules';
import { Badge, Divider, Input, Popover, Select, Switch } from 'antd';
import { FadPagesModel } from 'models/ferramentaAutoria/FadPagesModel';
import { FadPagesService } from 'core/http/service/ferramentaAutoria/FadPages.service';
import { FadRelationsPageService } from 'core/http/service/ferramentaAutoria/FadRelationsPage.service';
import { FadRelationsPageModel } from 'models/ferramentaAutoria/FadRelationsPageModel';
import ModalFormCourse from '../components/modals/ModalFormCourse';
import { FerramentaAutoriaContext } from '../context/FerramentaAutoriaContext';
import TipoRedirecionamento from 'enums/TipoRedirecionamento';
import { HiLockClosed } from 'react-icons/hi';
import { TbMessage } from 'react-icons/tb';
import { FadClassesModel } from 'models/ferramentaAutoria/FadClassesModel';
import { FadClassesService } from 'core/http/service/ferramentaAutoria/FadClasses.service';
import { FadInformationsExclusiveCourseModel } from 'models/ferramentaAutoria/FadInformationsExclusiveCourseModel';
import { CertificacoesModel } from 'models/certificacoes/CertificacoesModel';
import { FAD_Row1 } from '../AdminFerramentaAutoria.styled';
import ReactQuill from 'react-quill';
import { isArray } from 'lodash';
import editorConfig from 'pages/diarioBordo/components/textEditor/editorConfig';

const Styled = {
    Container: styled.div`
        padding: 20px;
        margin-bottom: 50px;
        display: flex;
        flex-direction: column;
        background-color: ${Colors.White};
    `,

    ContentBeet: styled.div`
        display: flex;
        align-items: center;
        justify-content: space-between;
    `,

    Row: styled.div`
        display: flex;
        align-items: center;
        gap: 16px;
    `,

    Column: styled.div`
        display: flex;
        align-items: center;
        flex-direction: column;
        gap: 16px;
    `,

    SubTitle: styled.h2`
        font-family: 'Barlow';
        font-size: 14px;
        font-weight: 600;
        line-height: 19.6px;
        text-align: left;
        text-underline-position: from-font;
        text-decoration-skip-ink: none;
    `,

    ColumnForm: styled.div`
        display: flex;
        flex-direction: column;
        gap: 4px;
    `,

    LabelForm: styled.h3`
        //styleName: Base/Legenda 2;
        font-family: 'Barlow';
        font-size: 14px;
        font-weight: 600;
        line-height: 19.6px;
        text-align: left;
        text-decoration-skip-ink: none;
        color: ${Colors.Blue};
    `,
    LabelForm2: styled.h3`
        //styleName: Base/Legenda 2;
        //styleName: Base/Corpo;
        font-family: 'Barlow';
        font-size: 16px;
        font-weight: 400;
        line-height: 24px;
        text-align: left;
        text-decoration-skip-ink: none;
        color: #666666;
    `,

    TextTitle: styled.h1`
        font-family: 'Barlow';
        font-size: 22px;
        font-weight: 600;
        line-height: 26.4px;
        text-align: left;
        width: 520px; /* Defina a largura desejada */
        white-space: nowrap; /* Impede a quebra de linha */
        overflow: hidden; /* Esconde o texto que excede a largura */
        text-overflow: ellipsis; /* Adiciona '...' ao final do texto */
        color: ${Colors.Blue};
    `,
};

const InitialFormCourse = FadCoursesModel.fromJSON({
    codigo: -1,
    codigoCertificado: -1,
    name: '',
    description: '',
    url: '',
    typeRedirect: TipoRedirecionamento.IGNORAR, // Assuming TipoRedirecionamentoEnum is converted to String
    template: TemplateCourseFadEnum.Lateral,
    sequentialContents: false,
    sequentialSteps: false,
    hasExclusiveContent: false,
    isPublic: false,
    ordem: 1,
});
const serviceFadCourses = new FadCoursesService();
const serviceClasses = new FadClassesService();

const AdminFadCourseEdit = () => {
    const history = useHistory();
    const params: any = useParams();

    //Variaveis
    const [course, setCourse] = useState<FadCoursesModel>(new FadCoursesModel());

    //services

    const { updateCourse, certificados, courseModel } = useContext(FerramentaAutoriaContext.Context);

    const [classes, setClasses] = useState<FadClassesModel[]>([]);
    const [inValid, setValid] = useState<boolean>(false);
    const [form, setForm] = useState<FadCoursesModel>(InitialFormCourse);

    const [loading, setLoading] = useState<boolean>(false);

    const handleUpdate = async () => {
        setLoading(true);

        if (form) {
            form.isPublic = course.isPublic;

            const novoForm = form;
            novoForm.url = '/' + novoForm.url;

            updateCourse(novoForm);
        }
        setLoading(false);
    };

    const fetchCourse = async () => {
        const { data, status } = await serviceFadCourses.findById(params.idCurso);

        if (status === 200) {
            setCourse(data);
            setForm(data);
        }
    };

    const handleNewDescription = () => {
        const newDescription = new FadInformationsExclusiveCourseModel();
        if (form.informationsExclusives && form.informationsExclusives.length > 0) {
            setForm((prevForm: any) => ({
                ...prevForm,
                informationsExclusives: [...prevForm.informationsExclusives, newDescription],
            }));
        } else {
            setForm((prevForm: any) => ({
                ...prevForm,
                informationsExclusives: [newDescription],
            }));
        }
    };

    const handleNewCertificacao = () => {
        const newCertificacao: IFadClasseCertificado = {
            codigo: -1,
            certificado: new CertificacoesModel(),
            classesDTO: [],
        };

        if (form.certificados && form.certificados.length > 0) {
            setForm((prevForm: any) => ({
                ...prevForm,
                certificados: [...prevForm.certificados, newCertificacao],
            }));
        } else {
            setForm((prevForm: any) => ({
                ...prevForm,
                certificados: [newCertificacao],
            }));
        }
    };

    useFetch(async () => {
        const { data, status } = await serviceClasses.findByFadCoursesCodigoPrivate(form.codigo);

        if (status === 200) {
            setClasses(data);
        }
    }, [course]);

    useEffect(() => {
        if (form.name.length > 2 && form.description.length > 2 && form.url.length > 2) {
            return setValid(true);
        }

        setValid(false);
    }, [form]);

    useEffect(() => {
        fetchCourse();
    }, [params]);

    useEffect(() => {
        fetchCourse();
    }, []);

    useEffect(() => {
        if (courseModel) {
            setCourse(courseModel);
        }
    }, [courseModel]);

    const goToBack = () => {
        history.push('/admin/ferramenta-autoria/curso/' + course.codigo);
    };

    return (
        <Styled.Container>
            <FAD_Button_Outline styles={{ width: '200px' }} icon={<IoIosArrowBack />} text="Voltar" onClick={goToBack} />
            {course && (
                <>
                    <Styled.ColumnForm style={{ borderTop: '1px solid #F0F0F0', paddingTop: 22 }}>
                        <Styled.LabelForm>Nome do curso</Styled.LabelForm>
                        <Input
                            showCount
                            value={form.name}
                            maxLength={115}
                            onChange={e => {
                                setForm((prev: any) => ({ ...prev, name: e.target.value }));
                            }}
                            placeholder="Digite o nome do curso"
                            size="large"
                        />
                    </Styled.ColumnForm>
                    <Styled.ColumnForm style={{ borderTop: '1px solid #F0F0F0', paddingTop: 22 }}>
                        <Styled.LabelForm>Descrição do curso - principal</Styled.LabelForm>
                        <ReactQuill
                            value={form.description}
                            modules={editorConfig.modules}
                            formats={editorConfig.formats}
                            onChange={v => {
                                setForm((prev: any) => ({ ...prev, description: v }));
                            }}
                            placeholder="Digite a descrição do curso"
                        />
                    </Styled.ColumnForm>
                    {form?.hasExclusiveContent && (
                        <div style={{ display: 'flex', flexDirection: 'column', gap: '1rem' }}>
                            {form?.informationsExclusives &&
                                form?.informationsExclusives?.length > 0 &&
                                form?.informationsExclusives.map((dados, index) => (
                                    <Styled.ColumnForm key={index} style={{ borderTop: '1px solid #F0F0F0', paddingTop: 22 }}>
                                        <Styled.LabelForm>Descrição do curso ( {index + 1} )</Styled.LabelForm>
                                        <ReactQuill
                                            value={dados.text}
                                            modules={editorConfig.modules}
                                            formats={editorConfig.formats}
                                            onChange={v => {
                                                setForm((prev: any) => {
                                                    const updatedInformations = [...prev.informationsExclusives];
                                                    updatedInformations[index] = {
                                                        ...updatedInformations[index],
                                                        text: v,
                                                    };
                                                    return {
                                                        ...prev,
                                                        informationsExclusives: updatedInformations,
                                                    };
                                                });
                                            }}
                                            placeholder="Digite a descrição do curso"
                                        />
                                        <Select
                                            allowClear
                                            mode="multiple"
                                            style={{ width: '100%' }}
                                            placeholder="Classes"
                                            size="large"
                                            value={classes
                                                .filter(c => dados.fadClasses.includes(c.codigo))
                                                .map(dc => ({ label: dc.name, value: dc.codigo }))}
                                            onChange={v => {
                                                setForm((prev: any) => {
                                                    const updatedInformations = [...prev.informationsExclusives];
                                                    updatedInformations[index] = {
                                                        ...updatedInformations[index],
                                                        fadClasses: isArray(v) ? v : [v],
                                                    };
                                                    return {
                                                        ...prev,
                                                        informationsExclusives: updatedInformations,
                                                    };
                                                });
                                            }}
                                            options={classes.map(c => ({ label: c.name, value: c.codigo }))}
                                        />
                                    </Styled.ColumnForm>
                                ))}

                            <FAD_Button_Primary text="Adicionar nova descrição" onClick={handleNewDescription} />
                        </div>
                    )}
                    <Styled.ColumnForm style={{ paddingTop: 10 }}>
                        <Styled.LabelForm>URL</Styled.LabelForm>
                        <Input
                            addonBefore="/"
                            value={form.url.toLocaleLowerCase().replace(/\//g, '')}
                            showCount
                            maxLength={100}
                            onChange={e => {
                                setForm((prev: any) => ({ ...prev, url: e.target.value.replace(/\//g, '').trim() }));
                            }}
                            placeholder="Digite a url do curso"
                            size="large"
                        />
                    </Styled.ColumnForm>
                    <Styled.ColumnForm style={{ paddingTop: 10 }}>
                        <Styled.LabelForm>Tipo de redirecionamento</Styled.LabelForm>
                        <Select
                            placeholder="Selecione"
                            value={form.typeRedirect}
                            onChange={value => {
                                setForm((prev: any) => ({ ...prev, typeRedirect: value }));
                            }}
                            options={[
                                { value: 'L', label: 'Login' },
                                { value: 'C', label: 'Cadastro' },
                                { value: 'I', label: 'Ignorar' },
                            ]}
                            size="large"
                        />
                    </Styled.ColumnForm>
                    <Styled.ColumnForm style={{ paddingTop: 10 }}>
                        {form?.certificados && form.certificados.length > 0 && (
                            <>
                                {form.certificados.map((cert, index) => (
                                    <React.Fragment key={index}>
                                        <Styled.LabelForm>Tipo de certificação ( {index + 1} )</Styled.LabelForm>
                                        <Select
                                            placeholder="Selecione"
                                            value={cert.certificado.codigo}
                                            onChange={value => {
                                                setForm((prev: any) => {
                                                    const certificado = [...prev.certificados];
                                                    certificado[index] = {
                                                        ...certificado[index],
                                                        certificado: certificados.filter(cf => cf.codigo === value)[0],
                                                    };

                                                    return {
                                                        ...prev,
                                                        certificados: certificado,
                                                    };
                                                });
                                            }}
                                            options={certificados.map(certificacao => ({
                                                value: certificacao.codigo,
                                                label: certificacao.nome,
                                            }))}
                                            size="large"
                                        />
                                        <Select
                                            allowClear
                                            mode="multiple"
                                            style={{ width: '100%' }}
                                            placeholder="Classes"
                                            size="large"
                                            value={cert.classesDTO.map(c => c.codigo)}
                                            onChange={(codigosSelecionados: number[]) => {
                                                const novasClasses = classes.filter(c => codigosSelecionados.includes(c.codigo));

                                                setForm((prev: any) => {
                                                    const certificadosAtualizados = [...prev.certificados];
                                                    certificadosAtualizados[index] = {
                                                        ...certificadosAtualizados[index],
                                                        classesDTO: novasClasses,
                                                    };
                                                    return {
                                                        ...prev,
                                                        certificados: certificadosAtualizados,
                                                    };
                                                });
                                            }}
                                            options={classes.map(c => ({
                                                label: c.name,
                                                value: c.codigo,
                                            }))}
                                        />
                                        <Divider />
                                    </React.Fragment>
                                ))}
                            </>
                        )}
                        <FAD_Button_Primary
                            styles={{ width: '420px', marginBottom: '40px' }}
                            text={
                                form?.certificados && form.certificados.length > 0 ? 'Adicionar nova certificação' : 'Adicionar uma certificação'
                            }
                            onClick={handleNewCertificacao}
                        />
                    </Styled.ColumnForm>
                    <FAD_Row1 style={{ marginTop: 10 }}>
                        <Switch
                            value={form.sequentialContents}
                            onChange={c => {
                                setForm((prev: any) => ({ ...prev, sequentialContents: c }));
                            }}
                        />
                        <Styled.LabelForm2>Conteúdos sequências</Styled.LabelForm2>
                    </FAD_Row1>
                    <FAD_Row1 style={{ marginTop: 10 }}>
                        <Switch
                            value={form.sequentialSteps}
                            onChange={c => {
                                setForm((prev: any) => ({ ...prev, sequentialSteps: c }));
                            }}
                        />
                        <Styled.LabelForm2>Etapas sequências</Styled.LabelForm2>
                    </FAD_Row1>
                    <FAD_Row1 style={{ marginTop: 10 }}>
                        <Switch
                            value={form.hasExclusiveContent}
                            onChange={c => {
                                setForm((prev: any) => ({ ...prev, hasExclusiveContent: c }));
                            }}
                        />
                        <Styled.LabelForm2>O curso tem partes exclusivas para diferentes turmas ?</Styled.LabelForm2>
                    </FAD_Row1>
                    <FAD_Row1 style={{ marginTop: 10 }}>
                        <Switch
                            value={form.finished}
                            onChange={c => {
                                setForm((prev: any) => ({ ...prev, finished: c }));
                            }}
                        />
                        <Styled.LabelForm2>O curso está completo ?</Styled.LabelForm2>
                    </FAD_Row1>
                </>
            )}
            <FAD_Button_Outline
                styles={{ width: '200px', marginTop: '40px' }}
                icon={<MdSaveAs />}
                text="Salvar alterações"
                onClick={handleUpdate}
                loading={loading}
            />
        </Styled.Container>
    );
};

export default AdminFadCourseEdit;
